import { Space } from "antd";
import styled from "styled-components";

export const Container = styled(Space)`
  width: 100%;
  max-width: 480px;
  height: 70px;
  padding: 0;
  align-items: center;
  text-align: center;
  position: fixed;
  bottom: 0;
  background: ${props => props.theme.navbarColor};

  .ant-space-item {
    flex: 0.25;
  }

  @media screen and (max-width: 395px) {
    gap: 0 !important;

    #icon-spin {
      width: 70px;
    }
  }
`;

export const ItemWrapper = styled.div`
  text-align: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0;

  #msg-active-icon {
    width: 26px;
    height: 26px;
  }
`;

export const Label = styled.div`
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  letter-spacing: normal;
  line-height: 1.5;
  color: ${(props) => (props.status === "active" ? "#FFFFFF" : "#E1A59C")};

  @media screen and (max-width: 352px) {
    font-size: 11px;
  }

  @media screen and (max-width: 330px) {
    font-size: 9px;
  }

  @media screen and (max-width: 298px) {
    font-size: 9px;
  }

  @media screen and (max-width: 272px) {
    font-size: 8px;
  }
`;
